import axiosInstance from './axiosInstance';
import { RemisionesResponse } from 'types/remisiones';

// Servicio para consultar remisiones por SKU
// Paginación: 30 elementos por página por defecto (opciones: 30, 60, 90, 100)

export const remisionesService = {
  getRemisionesBySKU: async (sku: string, page = 1, limit = 30): Promise<RemisionesResponse> => {
    const response = await axiosInstance.get(`/erp/productos/remisiones/${sku}`, {
      params: { page, limit }
    });
    return response.data;
  }
};
